import React, { useState, useEffect } from 'react'
import { _isloadinginitial, _homepagedata } from './RecoilState';
import axios from 'axios';
// import { Spin, Carousel } from 'antd';
// import { ArrowRightOutlined } from '@ant-design/icons';
import ProgramCard from './components/ProgramCard';
import Featureslider from './components/Featureslider';
import Youtubeembed from './components/Youtubeembed';
import Youtubeslider from './components/Youtubeslider';
import Highlightcard from './components/Highlightcard';
import FeaturedProgramCard from './components/FeaturedProgramCard';
import './App.css';
import contentdata from './assets/contentdata.json'
import { Link } from "react-router-dom";
import { useRecoilState } from 'recoil';


const App = () => {
  const [landingcards, setLandingcards] = useState([])
  const [featurecards, setFeaturecards] = useState([])
  const [featurevideos, setFeaturevideos] = useState([])
  const [parentsspeak, setParentsspeak] = useState([])
  const [homepagedata, setHomepagedata] = useRecoilState(_homepagedata)

  const data = contentdata;
  // console.log(data);

  useEffect(() => {
    setLandingcards(homepagedata.programs_homepage)
    setFeaturecards(homepagedata.usp_list_one_homepage)
    setFeaturevideos(homepagedata.featured_videos_one_homepage)
    setParentsspeak(homepagedata.parents_speak_videos_one_homepage)
  }, [])


  return (
    <div>
      {/* heading */}
      <div className='spacer'>
        <p className='brand-text large-gradient-heading'>{homepagedata.heading_one_homepage}</p>
      </div>

      {/* flashcards */}
      <div className='spacer flex flex-row flex-wrap -m-2'>
        {
          landingcards.map(card => (
            <div className='w-1/2'>
              <FeaturedProgramCard cardinfo={card} />
            </div>
          ))
        }
      </div>

      {/* subheading */}
      <div className='spacer'>
        <p className='brand-text gradient-heading'>{homepagedata.usp_heading_one_homepage}</p>
      </div>

      {/* featurecards */}
      <div className='spacer'>
        <Featureslider features={featurecards} />
        {/* <p className='brand-text gradient-small bottom7px'>Learn More</p> */}
      </div>

      {/* learn more yt video */}
      <div className='spacer'>
        <p className='brand-text gradient-heading bottom7px'>Experts Speak</p>
        <div className='flex flex-col gap-2'>
          {
            featurevideos.map(vid => (
              <div className='block'>
                <Youtubeembed videourl={vid.video} />
              </div>
            ))
          }
        </div>
      </div>

      {/* highlight card */}
      <div className='spacer'>
        <Highlightcard lineone={homepagedata.game_highlight_subheading_one_homepage} linetwo={homepagedata.game_highlight_subheading_two_homepage} linethree={homepagedata.game_highlight_heading_homepage} image={homepagedata.game_highlight_image_homepage} />
      </div>

      {/* parents speak yt carousel */}
      <div>
        <p className='brand-text gradient-small bottom7px'>Parents Speak</p>
        <Youtubeslider videos={parentsspeak} />
      </div>

    </div>
  )
}

export default App